import download from 'downloadjs';
import {uniq} from 'lodash';
import {unparse} from 'papaparse';

import {Site} from './api/project';
import {ApiForecastTimeSeries, ApiObservationTimeSeries} from './api/series';
import {getDataByTs} from './dataUtils';

export type CsvRow = Record<string, string | number | null>;

export function downloadCsvRows(rows: CsvRow[], filename: string) {
  download(unparse(rows), filename, 'text/csv');
}

export function downloadVizData(
  site: Site,
  observationTimeSeriesList: ApiObservationTimeSeries[] | undefined,
  forecastTimeSeriesList: ApiForecastTimeSeries[] | undefined,
  filename: string,
  timeZone: string = site.localTimeZone
) {
  const dataByTs = getDataByTs(site, observationTimeSeriesList, forecastTimeSeriesList, timeZone);

  const columnHeaders = uniq(Object.keys(dataByTs).flatMap((t) => Object.keys(dataByTs[t])));

  const csvString = unparse({
    fields: columnHeaders,
    data: Object.values(dataByTs),
  });

  download(csvString, filename, 'text/csv');
}
